import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "news-tabs-wrap"
};
const _hoisted_3 = {
  class: "news-tabs-group"
};
const _hoisted_4 = {
  class: "news-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "item-title"
};
const _hoisted_7 = {
  class: "item-row"
};
const _hoisted_8 = {
  class: "item-right"
};
const _hoisted_9 = {
  class: "item-date"
};
const _hoisted_10 = ["href", "download", "onClick"];
const _hoisted_11 = {
  class: "item-btn-read"
};
const _hoisted_12 = {
  class: "pagination"
};
import { ref, computed, onMounted, reactive } from 'vue';
import Footer from '@/components/footer';
import { useRouter } from 'vue-router';
import { menus, newsList } from '@/api';
import { getServerImage } from '@/utils/images';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const hearderbg = require('@/assets/newbg8c1668c.png');
    const activeTab = ref();
    const currentPage = ref(1);
    const pageSize = ref(5);
    const totalItems = ref(0); // 总条数
    const loading = ref(false);
    const finished = ref(true);
    const menusData = reactive([]);
    const dataList = reactive([]);

    // Tab切换处理
    const handleTabChange = () => {
      currentPage.value = 1;
      loadNewsData();
    };
    const handleDetail = item => {
      console.log('handleDetail: ', item);
      router.push({
        path: '/newsDetail',
        query: {
          id: item.id,
          type: activeTab.value
        }
      });
    };
    const handleDownload = url => {
      window.open(url, '_blank');
    };
    onMounted(() => {
      loadMenus();
    });
    const loadMenus = async () => {
      try {
        const {
          code,
          message,
          data
        } = await menus({
          type: 1
        });
        menusData.push(...data);
        activeTab.value = data[0].id;
        loadNewsData();
      } catch (error) {
        console.error('loadMenus error:', error);
      }
    };
    const loadNewsData = async () => {
      try {
        dataList.length = 0;
        const {
          code,
          message,
          data: {
            list,
            count
          }
        } = await newsList({
          mid: activeTab.value,
          page: currentPage.value,
          pageSize: pageSize.value
        });
        dataList.push(...list);
        totalItems.value = count;
      } catch (error) {
        console.log('loadNewsData error:', error);
      }
    };

    // 加载更多
    const onLoad = () => {
      setTimeout(() => {
        loading.value = false;
        if (currentPage.value * pageSize.value >= totalItems.value) {}
      }, 1000);
    };

    // 分页变化处理
    const handlePageChange = page => {
      console.log('handle page: ', page);
      currentPage.value = page;
      loadNewsData();
    };
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_pagination = _resolveComponent("van-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "news-header",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(hearderbg)})`
        })
      }, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "header-title-ch"
      }, "新闻动态", -1), _createElementVNode("div", {
        class: "header-title"
      }, "NEWS", -1)]))], 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
        shrink: "",
        active: activeTab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        "line-width": "5rem",
        "title-active-color": "#2bb061",
        color: "#2bb061",
        class: "news-tabs",
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menusData, item => {
          return _openBlock(), _createBlock(_component_van_tab, {
            name: item.id,
            title: item.name
          }, null, 8, ["name", "title"]);
        }), 256))]),
        _: 1
      }, 8, ["active"])])]), _createElementVNode("div", _hoisted_4, [dataList?.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
        key: 0,
        loading: loading.value,
        "onUpdate:loading": _cache[1] || (_cache[1] = $event => loading.value = $event),
        finished: finished.value,
        onLoad: onLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: item.id,
            onClick: $event => handleDetail(item)
          }, [_createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_image, {
            src: _unref(getServerImage)(item.imgUrl),
            alt: "新闻图片",
            class: "item-img",
            fit: "cover"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.create_time), 1), _createElementVNode("a", {
            href: item.annexUrl,
            "click.prevent.stop": "",
            download: item.title,
            onClick: _withModifiers($event => handleDownload(item.annexUrl), ["prevent", "stop"]),
            class: "item-btn-download"
          }, "文件下载", 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createTextVNode("阅读全文 ", -1)), _createVNode(_component_van_icon, {
            name: "arrow"
          })])])])], 8, _hoisted_5);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished"])) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "暂无数据"
      }))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_pagination, {
        style: {
          "min-width": "200px"
        },
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => currentPage.value = $event),
        "total-items": totalItems.value,
        "items-per-page": pageSize.value,
        onChange: handlePageChange,
        "force-ellipses": "",
        "show-page-size": "7"
      }, {
        "prev-text": _withCtx(() => [_createVNode(_component_van_icon, {
          name: "arrow-left"
        })]),
        "next-text": _withCtx(() => [_createVNode(_component_van_icon, {
          name: "arrow"
        })]),
        page: _withCtx(({
          text
        }) => [_createTextVNode(_toDisplayString(text), 1)]),
        _: 1
      }, 8, ["modelValue", "total-items", "items-per-page"])]), _createVNode(_unref(Footer))]);
    };
  }
};